import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

class FormaterString extends Component {
 /* static propTypes = {
      value: PropTypes.string,
      value: PropTypes.number
    };
    */
   
    constructor(props) {
      super(props);  
      this.state = {
        curvalue: this.props.value
      }
    }

    shouldComponentUpdate(nextProps) {
      return nextProps.value !== this.props.value;
    }

  render() { 
      let curvalue
      if (this.props.value !== null)  curvalue = this.props.value
      //return <div style = {{textAlign : this.props.Align,color : this.props.Color}} title={this.state.curvalue}>{this.state.curvalue}</div>;
      return <div style={{
        textAlign: this.props.Align, color: this.props.Color,wordWrap: 'break-word',wordBreak: 'break-all'}} title={this.state.curvalue}>{curvalue}</div>;
    }
  }

  export default FormaterString;  